export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "legDownload.worker.0dbf3cbe89fcfe87b33c-legDownload.worker.worker.js");
}
